import React from 'react';
import { Crown, Users, Wallet, ShieldCheck, Settings2, TrendingUp } from 'lucide-react';
import { useReveal, revealStyle } from './shared';

const FEATURES = [
  {
    icon: Crown,
    title: 'Your brand, not theirs',
    copy: "Renters book under your name and experience your brand, not a marketplace's.",
  },
  {
    icon: Users,
    title: 'Direct relationships',
    copy: 'Own every renter relationship and their contact details from day one.',
  },
  {
    icon: Wallet,
    title: 'Accept all payments',
    copy: 'Control how you get paid, your payout terms, and your own pricing.',
  },
  {
    icon: ShieldCheck,
    title: 'Insurance strategy',
    copy: 'Choose embedded On Rent and Off Rent coverages or "BYOI" bring your own insurance.',
  },
  {
    icon: Settings2,
    title: 'Automated operations',
    copy: 'Automated and manual rental workflows customized and built the way you want.',
  },
  {
    icon: TrendingUp,
    title: 'Scale on your terms',
    copy: 'Grow your fleet with personal, leisure, gig-economy, rideshare rental revenue channels.',
  },
];

/** Intro — "Marketplaces aren't the answer. You are." */
const IntroSection = () => {
  const { ref, shown } = useReveal();
  const { ref: featuresRef, shown: featuresShown } = useReveal();

  return (
    <section className="mpa-container mpa-intro">
      <div ref={ref}>
        <div className="mpa-intro-grid">
          {/* Left — eyebrow + big heading */}
          <div>
            <p className="mpa-eyebrow mpa-intro-eyebrow" style={revealStyle(shown, 0)}>
              A real Turo alternative
            </p>
            <h2 className="mpa-intro-title" style={revealStyle(shown, 150)}>
              You&apos;re in
              <br />
              full control
            </h2>
          </div>

          {/* Right — headline, subcopy */}
          <div className="mpa-intro-right">
            <h3 className="mpa-intro-headline">
              <span style={revealStyle(shown, 300)}>Marketplaces help you rent on their platform.</span>
              <span className="mpa-shimmer mpa-intro-headline-strong" style={revealStyle(shown, 550)}>
                Rentid helps you build your own business.
              </span>
            </h3>

            <p className="mpa-intro-copy" style={revealStyle(shown, 800)}>
              You&apos;re in control to own, grow, and scale with your brand, your renters, your
              payments, your insurance strategy, and your operations all working around you.
              <br />
              <span className="mpa-intro-strong">Your fleet. Your business. Your infrastructure.</span>
            </p>
          </div>
        </div>

        {/* Feature grid — 3 columns x 2 rows, revealed as it scrolls into view */}
        <ul ref={featuresRef} className="mpa-features-grid">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <li key={f.title} style={revealStyle(featuresShown, i * 110)}>
                <span className="mpa-feature-icon">
                  <Icon size={20} strokeWidth={2} />
                </span>
                <p className="mpa-feature-title">{f.title}</p>
                <p className="mpa-feature-copy">{f.copy}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default IntroSection;
